import { SeatsIOSeat } from "~components/reservation/constants";
import { holdSeats } from "~features/seated-reservation/graphql/mutations";
import { addPropertiesToSeats } from "~features/seated-reservation/helpers/addPropertiesToSeats";
import { log } from "~features/seated-reservation/helpers/stateLogger";
import { showToast } from "~lib";
import { getState, setState } from "../index";

interface ActionProps {
  categoryKey: number[];
}

const delay = async (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));

export const selectBestSeats = async (payload?: ActionProps) => {
  log("selectBestSeats", payload);

  const state = getState();

  if (state.selectionType === "user" || !state.selectBestOnChange) {
    // Disable auto select when a user has current selection
    return;
  }

  const categoryKey = payload?.categoryKey || state.categoryKey;
  const orgId = state.orgId;
  const seatsEventKey = state.seatsEventKey;

  if (!categoryKey) {
    console.error("No category key to select best seats");
    return;
  }

  setState({
    selectFailed: false,
    busyState: "finding-best-seats",
  });

  // Clear existing seat selection on the chart if there is one
  void state.chart.clearSelection();

  const result = await holdSeats(orgId, {
    holdToken: state.chart.holdToken,
    seatsEventId: seatsEventKey,
    number: state.options.amount,
    categories: categoryKey,
  });

  if (!result) {
    // TODO: dispatch error message
    return setState({
      selectFailed: true,
      busyState: "idle",
    });
  }

  const seatsNotFoundError = () => {
    // If held seats have not come through to the chart
    // via the chart API then they will not be in a "selected"
    // state in the chart and `clearSelection` will not do anything.
    void state.chart.clearSelection();
    void state.chart.resetView();

    showToast(
      "Opps something went wrong. Please clearing your selection and trying again.",
      "error"
    );

    return setState({
      selectFailed: true,
      busyState: "idle",
    });
  };

  const seats: SeatsIOSeat[] = [];

  for (const label of result.holdBestAvailableSeats.objects) {
    // TODO: Do we need to handle not found?
    const object: SeatsIOSeat = await state.chart.findObject(label);
    seats.push(object);
  }

  if (!seats.length) {
    void state.chart.clearSelection();
    return setState({
      selectFailed: true,
      busyState: "idle",
    });
  }

  const newSeats = addPropertiesToSeats({
    seats,
    multiBuyPromotions: state.multiBuyPromotions,
    eventTicketTypes: state.eventTicketTypes,
    releasedZones: state.releasedZones,
  });

  // TODO: need to wait for items to arrive at chart for
  // zoom to work. Can we can do it smarter than artificial delay?
  await delay(1000);
  void state.chart.zoomToSelectedObjects();

  return setState({
    busyState: "idle",
    categoryKey,
    selectionType: "auto",
    seats: newSeats,
  });
};
